import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { Trans } from "react-i18next";
import { GrPlan } from "react-icons/gr";
import { FaUserCircle } from "react-icons/fa";
import { FaQuestionCircle } from "react-icons/fa";
import { GoProjectRoadmap } from "react-icons/go";
import { RiRoadMapFill } from "react-icons/ri";
import { BsCollection } from "react-icons/bs";
import { GiToken } from "react-icons/gi";
import { MdOutlineStackedLineChart } from "react-icons/md";
import { RiGift2Line } from "react-icons/ri";
import { GiArrowScope } from "react-icons/gi";
import { IoSettingsSharp } from "react-icons/io5";
import { MdQueryStats } from "react-icons/md";
import { IoPricetags } from "react-icons/io5";
import { GiRingedPlanet } from "react-icons/gi";
import { RiBuilding2Fill } from "react-icons/ri";
import { LiaShipSolid } from "react-icons/lia";
import { MdChecklist } from "react-icons/md";
import { FaRegNewspaper } from "react-icons/fa6";
import { MdOutlineSocialDistance } from "react-icons/md";

import { CiViewList } from "react-icons/ci";
import { MdOutlineContactPhone } from "react-icons/md";
const Sidebar = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);

  const toggleMenuState = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  // useEffect(() => {
  //   setActiveMenu(null); // Close all menus on route change
  // }, [location.pathname]);
  const accordionSections = useMemo(
    () => [
      {
        id: "collapseFive",
        paths: ["/dashboard"],
      },
      {
        id: "collapseOne",
        paths: ["/users", "/contactlist", "/collectionlist", "/tokenlist"],
      },
      {
        id: "collapseTwo",
        paths: ["/plans", "/faq", "/cmslist", "/roadmaplist"],
      },
      {
        id: "collapseThree",
        paths: [
          "/poollist",
          "/missionrewardlist",
          "/game-mission-values",
          "/game-settings",
          "/mission-stats",
          "/crew-price",
          "/planet-and-asteroid-price",
          "/building",
          "/ship",
        ],
      },
      {
        id: "collapseFour",
        paths: [
          "/bloglist",
          "/newslist",
          "/sociallist",
          "/partners",
          "/publishlist",
          "/promobuildlist",
          "/uploadpdf",
        ],
      },
    ],
    [],
  );

  useEffect(() => {
    const matchedSection = accordionSections.find(({ paths }) =>
      paths.some((p) => location.pathname.startsWith(p)),
    );
    if (matchedSection) {
      setActiveMenu(matchedSection.id); // Keep the relevant section open
    }
  }, [location.pathname, accordionSections]);

  const dropdownPaths = useMemo(
    () => [
      { path: "/apps", state: "appsMenuOpen" },
      { path: "/basic-ui", state: "basicUiMenuOpen" },
      { path: "/form-elements", state: "formElementsMenuOpen" },
      { path: "/tables", state: "tablesMenuOpen" },
      { path: "/icons", state: "iconsMenuOpen" },
      { path: "/charts", state: "chartsMenuOpen" },
      { path: "/user-pages", state: "userPagesMenuOpen" },
      { path: "/error-pages", state: "errorPagesMenuOpen" },
    ],
    [],
  );

  const isPathActive = (path) => location.pathname.startsWith(path);

  // const NavItem = ({ path, icon: Icon, label }) => (
  //   <li className="nav-item">
  //     <Link
  //       className={`nav-link ${isPathActive(path) ? "active" : ""}`}
  //       to={path}
  //     >
  //       <Trans>
  //         <Icon className="mr-2" />
  //         {label}
  //       </Trans>
  //     </Link>
  //   </li>
  // );
  const NavItem = ({ path, icon: Icon, label }) => {
    const active = isPathActive(path);
    return (
      <li className="nav-item">
        <Link
          className={`nav-link ${active ? "active" : ""}`}
          to={path}
          style={active ? { color: "#a04e80" } : {}}
        >
          <Trans>
            <Icon className="mr-2" />
            {label}
          </Trans>
        </Link>
      </li>
    );
  };

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
        <Link className="sidebar-brand brand-logo" to="/plans">
          <img src={require("../../assets/images/logos.png")} alt="logo" />
        </Link>
        <Link className="sidebar-brand brand-logo-mini" to="/plans">
          <img src={require("../../assets/images/sullamlogo.png")} alt="logo" />
        </Link>
      </div>
      <ul className="nav mt-3">
        <div className="accordion" id="accordionExample">
          <li className="nav-item">
            <Link
              className={`nav-link dashboardFont ${location.pathname === "/dashboard" ? "active" : ""
                }`}
              to="/dashboard"
            >

              Dashboard
            </Link>
          </li>
          {[
            {
              title: "NFT MarketPlace Site",
              id: "collapseOne",
              items: [
                { path: "/users", icon: FaUserCircle, label: "Users" },
                {
                  path: "/contactlist",
                  icon: MdOutlineContactPhone,
                  label: "Subscribers",
                },
                {
                  path: "/collectionlist",
                  icon: BsCollection,
                  label: "Collection",
                },
                {
                  path: "/tokenlist",
                  icon: GiToken,
                  label: "Tokens",
                },
              ],
            },
            {
              title: "CMS",
              id: "collapseTwo",
              items: [
                { path: "/plans", icon: GrPlan, label: "Planet CMS" },
                { path: "/faq", icon: FaQuestionCircle, label: "FAQ" },
                { path: "/cmslist", icon: CiViewList, label: "CMS" },
                {
                  path: "/roadmaplist",
                  icon: RiRoadMapFill,
                  label: "Roadmap",
                },
              ],
            },
            {
              title: "Game Site",
              id: "collapseThree",
              items: [
                {
                  path: "/shiplist",
                  icon: MdOutlineContactPhone,
                  label: "Ship",
                },
                // { path: "/crewlist", icon: MdOutlineContactPhone, label: "Crew" },
                // {
                //   path: "/missionstats",
                //   icon: MdOutlineContactPhone,
                //   label: "Hard Stake Pool",
                // },
                {
                  path: "/poollist",
                  icon: MdOutlineStackedLineChart,
                  label: "Hard Stake Pool",
                },
                {
                  path: "/missionrewardlist",
                  icon: RiGift2Line,
                  label: "Mission Reward",
                },
                {
                  path: "/mission-bonus-reward",
                  icon: RiGift2Line,
                  label: "Crew Mission Bonus",
                },
                {
                  path: "/game-mission-values",
                  icon: GiArrowScope,
                  label: "Mission Scope ",
                },
                {
                  path: "/mission-stats",
                  icon: MdQueryStats,
                  label: "Mission Status ",
                },
                {
                  path: "/game-settings",
                  icon: IoSettingsSharp,
                  label: "Game Settings ",
                },
                {
                  path: "/crew-price",
                  icon: IoPricetags,
                  label: "CrewPrice",
                },
                {
                  path: "/planet-and-asteroid-price",
                  icon: GiRingedPlanet,
                  label: "PlanetAndAsteroidPrice",
                },
                {
                  path: "/building",
                  icon: RiBuilding2Fill,
                  // label: "BUILDINGS",
                  label: "Buildings",
                },
              ],
            },
            {
              title: "Promotion Site",
              id: "collapseFour",
              items: [
                {
                  path: "/bloglist",
                  icon: MdChecklist,
                  label: "Blog List",
                },
                {
                  path: "/newslist",
                  icon: FaRegNewspaper,
                  label: "News List",
                },
                {
                  path: "/sociallist",
                  icon: MdOutlineContactPhone,
                  label: "Social List",
                },
                {
                  path: "/partners",
                  icon: MdOutlineContactPhone,
                  label: "Partners",
                },
                {
                  path: "/publishlist",
                  icon: MdOutlineContactPhone,
                  label: "Publish",
                },
                {
                  path: "/promobuildlist",
                  icon: MdOutlineContactPhone,
                  label: "Promo Build",
                },
                {
                  path: "/uploadpdf",
                  icon: MdOutlineContactPhone,
                  label: "WhitePaper",
                },
              ],
            },
          ].map(({ title, id, items }) => (
            <div className="accordion-item" key={id}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${activeMenu === id ? "" : "collapsed"
                    }`}
                  type="button"
                  onClick={() => toggleMenuState(id)}
                  aria-expanded={activeMenu === id}
                >
                  {title}
                </button>
              </h2>
              <div
                id={id}
                className={`accordion-collapse collapse ${activeMenu === id ? "show" : ""
                  }`}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body pt-2">
                  <ul className="nav flex-column sub-menu pl-3">
                    {items.map(({ path, icon, label }) => (
                      <NavItem
                        key={path}
                        path={path}
                        icon={icon}
                        label={label}
                      />
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </ul>
    </nav>
  );
};

export default Sidebar;
